import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { findIndex, uniqBy } from 'lodash';

import { WorkShiftsTemplateFilterService } from './work-shifts-template-filter.service';
import { WorkShiftsService } from '../../work-shifts.service';
import { Enums } from '../../../../configs/Enums';
import { AuthService } from '../../../auth/auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-work-shifts-template-filter',
  templateUrl: './work-shifts-template-filter.component.html',
  styleUrls: ['./work-shifts-template-filter.component.scss'],
  standalone: false,
})
export class WorkShiftsTemplateFilterComponent implements OnInit {
  moment = require('moment');
  templateError;
  previewDisabled = false;
  workPlacesList;

  @Input() filter;
  @Input() templateFilter;
  @Input() templateFilterData;

  @Output() onResetTemplateFilter = new EventEmitter<any>();
  @Output() onSaveTemplatePeriod = new EventEmitter<any>();
  @Output() onPreloadTemplatePeriod = new EventEmitter<any>();

  constructor(
    private workShiftsTemplateFilterService: WorkShiftsTemplateFilterService,
    private workShiftsService: WorkShiftsService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.initUiData(this.templateFilter.workTypeSelected);

    if (this.templateFilterData.workPlacesList && this.templateFilterData.workPlacesList.length) {
      this.workPlacesList = this.templateFilterData.workPlacesList.filter((place) => {
        return place.sector_id !== this.filter.plotSelected.sector_id;
      });
    }
  }

  initUiData(cellTypeSelected) {
    if (cellTypeSelected && cellTypeSelected.ct_id === 1) {
      let cellIndex = findIndex(this.templateFilterData.scheduleTypesList, {
        st_id: 1,
      });

      if (cellIndex > -1) {
        this.onChangeTemplateCellType(this.templateFilterData.scheduleTypesList[cellIndex]);
      }

      this.onChangeStartTemplatePeriodTime({ hour: 9, minute: 0 });
      this.onChangeEndTemplatePeriodTime({ hour: 18, minute: 0 });
      this.templateFilter.commentary = null;
    }

    if (cellTypeSelected && cellTypeSelected.ct_id === 2) {
      this.onChangeTemplateWorkPlace(null);
    }
  }

  onChangeTemplateWorkType(selected) {
    this.templateFilter.workTypeSelected = selected;

    this.initUiData(selected);
    this.checkPreviewEnabled();
  }

  onChangeStartTemplatePeriodDate(dateObj) {
    this.templateFilter.startTemplatePeriod = Object.assign(this.templateFilter.startTemplatePeriod, dateObj);

    if (dateObj && dateObj.dateMillis) {
      this.templateFilter.endTemplatePeriodOpts = {
        minDate: this.moment(dateObj.dateMillis).add(-1, 'day').format('YYYY-MM-DD HH:MM:ss'),
        maxDate: this.moment(dateObj.dateMillis).endOf('month').format('YYYY-MM-DD HH:MM:ss'),
      };
    } else {
      this.templateFilter.startTemplatePeriod.initDate = null;
    }

    this.checkPreviewEnabled();
  }

  onChangeEndTemplatePeriodDate(dateObj) {
    this.templateFilter.endTemplatePeriod = Object.assign(this.templateFilter.endTemplatePeriod, dateObj);

    if (dateObj && !dateObj.dateMillis) {
      this.templateFilter.endTemplatePeriod.initDate = null;
    }

    this.checkPreviewEnabled();
  }

  onChangeTemplateCellType(selected) {
    this.templateFilter.cellTypeSelected = selected;
  }

  onChangeStartTemplatePeriodTime(time) {
    this.templateFilter.startWorkTime = time;

    this.checkPreviewEnabled();
  }

  onChangeEndTemplatePeriodTime(time) {
    this.templateFilter.endWorkTime = time;

    this.checkPreviewEnabled();
  }

  onChangeTemplateWorkPlace(selected) {
    this.templateFilter.workPlaceSelected = selected;

    this.checkPreviewEnabled();
  }

  onChangeTemplateFilterPreviewModeState() {
    this.templateFilter.isActiveTemplateFilterPreviewMode = !this.templateFilter.isActiveTemplateFilterPreviewMode;
    this.templateError = null;
    this.makePreviewForSelectedUsers();
  }

  onRemoveSelectedUser(user) {
    user.isSelected = false;
    let index = findIndex(this.templateFilter.selectedUsers, {
      u_id: user.u_id,
    });

    if (index > -1) {
      this.templateFilter.selectedUsers.splice(index, 1);
    }
  }

  checkPreviewEnabled() {
    let templateFilter = this.templateFilter;
    let workTypeSelected = templateFilter.workTypeSelected;

    if (workTypeSelected && workTypeSelected.ct_id === 1) {
      this.previewDisabled = !(this.checkDateRange() && this.checkTimeRange());
    }

    if (workTypeSelected && workTypeSelected.ct_id === 2) {
      this.previewDisabled = !this.templateFilter.workPlaceSelected;
    }

    if (workTypeSelected && [1, 2].indexOf(workTypeSelected.ct_id) === -1) {
      this.previewDisabled = false;
    }
  }

  checkDateRange() {
    return !!(this.templateFilter.startTemplatePeriod.dateMillis && this.templateFilter.endTemplatePeriod.dateMillis);
  }

  checkTimeRange() {
    let templateFilter = this.templateFilter;
    let startPeriod =
      (templateFilter.startWorkTime.hour ? templateFilter.startWorkTime.hour * 60 * 1000 : 0) +
      (templateFilter.startWorkTime.minute ? templateFilter.startWorkTime.minute * 1000 : 0);
    let endPeriod =
      (templateFilter.endWorkTime.hour ? templateFilter.endWorkTime.hour * 60 * 1000 : 0) + (templateFilter.endWorkTime.minute ? templateFilter.endWorkTime.minute * 1000 : 0);

    return this.authService.isGRSUser() || startPeriod < endPeriod;
  }

  makePreviewForSelectedUsers() {
    const startPeriodDate = this.moment(this.templateFilter.startTemplatePeriod.dateMillis).format('YYYY-MM-DD');
    const endPeriodDate = this.moment(this.templateFilter.endTemplatePeriod.dateMillis).format('YYYY-MM-DD');
    const endMonthDate = this.moment(this.filter.monthDate.initDate).endOf('month').format('YYYY-MM-DD');
    const isPreviewEnabled = this.templateFilter.isActiveTemplateFilterPreviewMode;

    for (let i = 0; i < this.templateFilter.selectedUsers.length; i++) {
      let user = this.templateFilter.selectedUsers[i];
      let workDayType = this.templateFilter.workTypeSelected;

      if (isPreviewEnabled) {
        switch (workDayType.ct_id) {
          case 1:
            this.makeWorkDayPreview(user, startPeriodDate, endPeriodDate, endMonthDate);
            break;
          case 2:
            this.makeRelacatePreview(user, startPeriodDate, endPeriodDate, endMonthDate);
            break;
          default:
            this.makeOtherPreview(user, startPeriodDate, endPeriodDate, endMonthDate);
            break;
        }
      } else {
        user.working_shift.forEach((work_shift) => {
          work_shift.schedule_preview = null;
        });
      }
    }
  }

  makePreviewDataParamsObj() {
    return {
      comment: this.templateFilter.comment,
      startWorkTime: this.templateFilter.startWorkTime,
      endWorkTime: this.templateFilter.endWorkTime,
      weekend:
        this.templateFilterData.cellTypesList[
          findIndex(this.templateFilterData.cellTypesList, {
            ct_id: 8,
          })
        ],
      cellTypeSelected: this.templateFilter.cellTypeSelected,
      startPeriodDate: this.templateFilter.startPeriodDate,
      endPeriodDate: this.templateFilter.endPeriodDate,
      workTypeSelected: this.templateFilter.workTypeSelected,
      workPlaceSelected: this.templateFilter.workPlaceSelected,
    };
  }

  makeWorkDayPreview(user, startPeriodDate, endPeriodDate, endMonthDate) {
    const cellTypeSelected = this.templateFilter.cellTypeSelected;
    let countWork = 0;
    let countWikend = 0;
    let currentWork = 0;
    let currentWikend = 0;
    let previewData = this.makePreviewDataParamsObj();

    switch (cellTypeSelected.st_id) {
      case 1:
        countWork = 5;
        countWikend = 2;
        break;
      case 2:
        countWork = 2;
        countWikend = 2;
        break;
      default:
        break;
    }

    // Создаем карту уникальных дат для проверки дубликатов
    const processedDates = new Set();

    for (let i = 0; i < user.working_shift.length; i++) {
      let work_shift = user.working_shift[i];

      // Пропускаем дубликаты
      if (processedDates.has(work_shift.workday)) {
        work_shift.schedule_preview = null;
        continue;
      }
      processedDates.add(work_shift.workday);

      if (work_shift.workday >= startPeriodDate && work_shift.workday <= endPeriodDate) {
        if (currentWork === countWork && currentWikend === countWikend) {
          currentWork = 0;
          currentWikend = 0;
        }

        switch (cellTypeSelected.st_id) {
          case 1:
          case 2:
            // Исправленная логика: если currentWork < countWork, то это рабочий день
            let isWorkingDay = currentWork < countWork;

            work_shift.schedule_preview = this.workShiftsTemplateFilterService.makePreviewCell(work_shift, previewData, !isWorkingDay);

            if (isWorkingDay) {
              currentWork++;
            } else {
              currentWikend++;
            }

            break;
          case 3:
            work_shift.schedule_preview = this.workShiftsTemplateFilterService.makePreviewCell(work_shift, previewData, false);

            break;
          case 4:
            work_shift.schedule_preview = this.workShiftsTemplateFilterService.makePreviewCell(work_shift, previewData, true);

            break;
          default:
            break;
        }
      } else {
        work_shift.schedule_preview = null;
      }
    }
  }

  makeRelacatePreview(user, startPeriodDate, endPeriodDate, endMonthDate) {
    let previewData = this.makePreviewDataParamsObj();

    // Создаем карту уникальных дат для проверки дубликатов
    const processedDates = new Set();

    for (let i = 0; i < user.working_shift.length; i++) {
      let work_shift = user.working_shift[i];

      // Пропускаем дубликаты
      if (processedDates.has(work_shift.workday)) {
        work_shift.schedule_preview = null;
        continue;
      }
      processedDates.add(work_shift.workday);

      if (work_shift.workday >= startPeriodDate && work_shift.workday <= endPeriodDate) {
        work_shift.schedule_preview = this.workShiftsTemplateFilterService.makePreviewCell(work_shift, previewData, false);
      } else {
        work_shift.schedule_preview = null;
      }
    }
  }

  makeOtherPreview(user, startPeriodDate, endPeriodDate, endMonthDate) {
    let previewData = this.makePreviewDataParamsObj();

    // Создаем карту уникальных дат для проверки дубликатов
    const processedDates = new Set();

    for (let i = 0; i < user.working_shift.length; i++) {
      let work_shift = user.working_shift[i];

      // Пропускаем дубликаты
      if (processedDates.has(work_shift.workday)) {
        work_shift.schedule_preview = null;
        continue;
      }
      processedDates.add(work_shift.workday);

      if (work_shift.workday >= startPeriodDate && work_shift.workday <= endPeriodDate) {
        work_shift.schedule_preview = this.workShiftsTemplateFilterService.makePreviewCell(work_shift, previewData, false);
      } else {
        work_shift.schedule_preview = null;
      }
    }
  }

  onSaveCellsSelectedUsers() {
    const cells = this.workShiftsTemplateFilterService.makePeriodCell({
      templateFilter: this.templateFilter,
      templateFilterData: this.templateFilterData,
      filter: this.filter,
    });
    const requestObj = { single_creation: false, cells: cells };

    // Логируем данные для отладки
    console.log('Отправляемые данные:', requestObj);
    console.log('Количество ячеек для сохранения:', cells.length);

    this.templateError = null;
    this.onPreloadTemplatePeriod.emit(true);

    this.workShiftsService.saveOrEditCells(requestObj).subscribe(
      (response) => {
        console.log('Ответ сервера при сохранении:', response);
        this.onSaveTemplatePeriod.emit();
        this.onPreloadTemplatePeriod.emit(false);
      },
      (error) => {
        console.log('Ошибка при сохранении:', error);
        this.templateError = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
        this.onPreloadTemplatePeriod.emit(false);
      }
    );
  }
}
